import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class EmploymentLeaveActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/Leave/LeaveBrowser")
	}

	render() {
		return (
			<Activity 
				name="EmploymentLeave"
				RenderedComponent={this.RenderedComponent}
				context="EmploymentLeave"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(EmploymentLeaveActivity)
